import { INoticia } from "../../Interfaces/model/INoticia";
import { PurpleButton } from "../buttons/purpleButton";
import { WhiteCardContainer, WhiteCardContent, WhiteCardImage } from "./styles";

interface WhiteCardProps {
  news: INoticia;
  onClickDelete: () => void;
}

export const WhiteCard = ({ news, onClickDelete }: WhiteCardProps) => {
  return (
    <WhiteCardContainer>
      {news.imagem && <WhiteCardImage src={news.imagem} alt={news.titulo} />}
      <WhiteCardContent>
        <h3>{news.titulo}</h3>
        <p>
          {news.autor} {news.cidade ? `- ${news.cidade}` : ""}
        </p>
        <PurpleButton title="Deletar" onClick={onClickDelete} />
      </WhiteCardContent>
    </WhiteCardContainer>
  );
};
